// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';

export const Icon = styled.img`
  margin-right: 8px;
  vertical-align: bottom;
`;
